module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "no-avatar.ed99f9d0.webp";